import clx from 'classnames';
import {
  IProcedureBridgeAttachmentInfo,
  IProcedureBridgeDocumentInfo
} from 'common/dto/ProcedureBridgeDto';
import './ReadDocumentIcon.scss';

import React from 'react';

interface IReadDocumentIconProps {
  document?:
    | IProcedureBridgeAttachmentInfo
    | IProcedureBridgeDocumentInfo
    | null;
}

export function ReadDocumentIcon(props: IReadDocumentIconProps) {
  const { document } = props;

  return (
    <div className={clx('read-document-icon', { read: document?.read })} />
  );
}
